// Favorite heart. The artwork lives in public/img/heart-outline.svg and
// heart-filled.svg (same path on a square 576x576 viewBox, centered). Those
// files are pulled in as a CSS mask rather than an <img> so each listing can
// still tint the heart with its own category accent color - an <img> renders
// in the file's own colors and can't be recolored from the page.
function HeartIcon({ filled, color, className = '' }) {
  const src = filled ? '/img/heart-filled.svg' : '/img/heart-outline.svg';
  const maskStyles = {
    WebkitMaskImage: `url(${src})`,
    maskImage: `url(${src})`,
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    maskPosition: 'center',
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
    backgroundColor: color,
  };

  return <span aria-hidden="true" className={`inline-block ${className}`} style={maskStyles} />;
}

export default HeartIcon;
